module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "c10"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v("Is that a Nightstick in Your Pocket or Are You Just Happy to See Me?")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("I")]), _vm._v("n June 2003, Officer Jamie Hope was dispatched to a residence after receiving several noise complaints. When he knocked on the door at the bachelorette party in Gainesville, Florida, the partygoers assumed he was the hired entertainment. While the officer was speaking to guest of honor Nichole Neal, the other guests yelled, “The warning has gone far enough—when are you going to start stripping?” It took them a while to realize that handcuffing Neal wasn’t part of his kinky act. He was actually arresting her on an outstanding warrant. Not wanting to have their party ruined, the guests followed the patrol car to the station and paid Neal’s bail so they could return to the festivities."), _c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/Greg_9780740792069_epub_L02_r1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_c('em', [_vm._v("Fifty-eight percent of women cuddle after sex, but eight percent just “lie there silently.”")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-136f38e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780740792069_epub_c10_r1.vue
// module id = 102
// module chunks = 0